import { Component, inject } from '@angular/core';
import { LayoutService } from './service/layout.service';

@Component({
  standalone: true,
  selector: 'app-footer',
  template: `@if (layoutService.footerText()) {
    <div class="layout-footer">{{ layoutService.footerText() }}</div>
  }`,
})
export class AppFooter {
  layoutService = inject(LayoutService);
}
